import { Component, OnInit, ViewContainerRef, Renderer2, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';
import { LookupViewModel } from '../../view-models/lookup.view-model';

@Component({
  selector: 'ndms-phone-number',
  templateUrl: './ndms-phone-number.component.html',
  styleUrls: ['./ndms-phone-number.component.scss']
})
export class NdmsPhoneNumberComponent extends NdmsFormControlComponent implements OnInit {
    @Input() hideNote: boolean;
    @Input() numberRequired: boolean = false;

  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }

  ngOnInit() {
  }

  canAddArrayItem(currentIndex: number) {
    return true;
  }

  compareFn(c1: LookupViewModel, c2: LookupViewModel): boolean {
    return c1 && c2 ? c1.key === c2.key : c1 === c2;
  }

  getMask() {
    return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }
}
